/**
 * StdlibSLOrbStdlibRoute
 *
 * Page component for StdlibSLOrbStdlibRoute
 * Path: /sl/stdlib
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { StdlibSLOrbStdlibPageView as __StdlibSLOrbStdlibPageView } from '@/components/traits/StdlibSLOrbStdlibPageView';
import { StdlibSLOrbStdlibAnalyticsView as __StdlibSLOrbStdlibAnalyticsView } from '@/components/traits/StdlibSLOrbStdlibAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface StdlibSLOrbStdlibRouteProps {
  // Add any page-level props here
}

export function StdlibSLOrbStdlibRoute(_props: StdlibSLOrbStdlibRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-stdlib:meta.title"],"description":["i18n/t","std-orb-stdlib:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/stdlib"},{"locale":"ar","path":"/ar/stdlib"},{"locale":"sl","path":"/sl/stdlib"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__StdlibSLOrbStdlibPageView config={{ initPayload: __navState }} />
          <__StdlibSLOrbStdlibAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default StdlibSLOrbStdlibRoute;
